/* Do not edit directly — generated by scripts/tokens/build.mjs */

export const typography = {
  display2: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-display-2-size)",
    lineHeight: "var(--font-display-2-line-height)",
    fontWeight: "var(--font-display-2-weight)",
    letterSpacing: "var(--font-display-2-letter-spacing)",
  },
  display1: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-display-1-size)",
    lineHeight: "var(--font-display-1-line-height)",
    fontWeight: "var(--font-display-1-weight)",
    letterSpacing: "var(--font-display-1-letter-spacing)",
  },
  h1Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h1-sb-size)",
    lineHeight: "var(--font-h1-sb-line-height)",
    fontWeight: "var(--font-h1-sb-weight)",
    letterSpacing: "var(--font-h1-sb-letter-spacing)",
  },
  h1: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h1-size)",
    lineHeight: "var(--font-h1-line-height)",
    fontWeight: "var(--font-h1-weight)",
    letterSpacing: "var(--font-h1-letter-spacing)",
  },
  h2Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h2-sb-size)",
    lineHeight: "var(--font-h2-sb-line-height)",
    fontWeight: "var(--font-h2-sb-weight)",
    letterSpacing: "var(--font-h2-sb-letter-spacing)",
  },
  h2: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h2-size)",
    lineHeight: "var(--font-h2-line-height)",
    fontWeight: "var(--font-h2-weight)",
    letterSpacing: "var(--font-h2-letter-spacing)",
  },
  h3Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h3-sb-size)",
    lineHeight: "var(--font-h3-sb-line-height)",
    fontWeight: "var(--font-h3-sb-weight)",
    letterSpacing: "var(--font-h3-sb-letter-spacing)",
  },
  h3: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h3-size)",
    lineHeight: "var(--font-h3-line-height)",
    fontWeight: "var(--font-h3-weight)",
    letterSpacing: "var(--font-h3-letter-spacing)",
  },
  h4Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h4-sb-size)",
    lineHeight: "var(--font-h4-sb-line-height)",
    fontWeight: "var(--font-h4-sb-weight)",
    letterSpacing: "var(--font-h4-sb-letter-spacing)",
  },
  h4: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h4-size)",
    lineHeight: "var(--font-h4-line-height)",
    fontWeight: "var(--font-h4-weight)",
    letterSpacing: "var(--font-h4-letter-spacing)",
  },
  h5Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h5-sb-size)",
    lineHeight: "var(--font-h5-sb-line-height)",
    fontWeight: "var(--font-h5-sb-weight)",
    letterSpacing: "var(--font-h5-sb-letter-spacing)",
  },
  h5: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-h5-size)",
    lineHeight: "var(--font-h5-line-height)",
    fontWeight: "var(--font-h5-weight)",
    letterSpacing: "var(--font-h5-letter-spacing)",
  },
  actions14Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-actions-14-sb-size)",
    lineHeight: "var(--font-actions-14-sb-line-height)",
    fontWeight: "var(--font-actions-14-sb-weight)",
    letterSpacing: "var(--font-actions-14-sb-letter-spacing)",
  },
  actions12Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-actions-12-sb-size)",
    lineHeight: "var(--font-actions-12-sb-line-height)",
    fontWeight: "var(--font-actions-12-sb-weight)",
    letterSpacing: "var(--font-actions-12-sb-letter-spacing)",
  },
  body12: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-12-size)",
    lineHeight: "var(--font-body-12-line-height)",
    fontWeight: "var(--font-body-12-weight)",
    letterSpacing: "var(--font-body-12-letter-spacing)",
  },
  body14: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-14-size)",
    lineHeight: "var(--font-body-14-line-height)",
    fontWeight: "var(--font-body-14-weight)",
    letterSpacing: "var(--font-body-14-letter-spacing)",
  },
  body14Sb: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-14-sb-size)",
    lineHeight: "var(--font-body-14-sb-line-height)",
    fontWeight: "var(--font-body-14-sb-weight)",
    letterSpacing: "var(--font-body-14-sb-letter-spacing)",
  },
  body14M: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-14-m-size)",
    lineHeight: "var(--font-body-14-m-line-height)",
    fontWeight: "var(--font-body-14-m-weight)",
    letterSpacing: "var(--font-body-14-m-letter-spacing)",
  },
  body12M: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-12-m-size)",
    lineHeight: "var(--font-body-12-m-line-height)",
    fontWeight: "var(--font-body-12-m-weight)",
    letterSpacing: "var(--font-body-12-m-letter-spacing)",
  },
  bodySmall: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-small-size)",
    lineHeight: "var(--font-body-small-line-height)",
    fontWeight: "var(--font-body-small-weight)",
    letterSpacing: "var(--font-body-small-letter-spacing)",
  },
  bodyOverline: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-overline-size)",
    lineHeight: "var(--font-body-overline-line-height)",
    fontWeight: "var(--font-body-overline-weight)",
    letterSpacing: "var(--font-body-overline-letter-spacing)",
  },
  bodyFootnote: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-body-footnote-size)",
    lineHeight: "var(--font-body-footnote-line-height)",
    fontWeight: "var(--font-body-footnote-weight)",
    letterSpacing: "var(--font-body-footnote-letter-spacing)",
  },
  paragraphLargeM: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-large-m-size)",
    lineHeight: "var(--font-paragraph-large-m-line-height)",
    fontWeight: "var(--font-paragraph-large-m-weight)",
    letterSpacing: "var(--font-paragraph-large-m-letter-spacing)",
  },
  paragraphLarge: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-large-size)",
    lineHeight: "var(--font-paragraph-large-line-height)",
    fontWeight: "var(--font-paragraph-large-weight)",
    letterSpacing: "var(--font-paragraph-large-letter-spacing)",
  },
  paragraphMediumM: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-medium-m-size)",
    lineHeight: "var(--font-paragraph-medium-m-line-height)",
    fontWeight: "var(--font-paragraph-medium-m-weight)",
    letterSpacing: "var(--font-paragraph-medium-m-letter-spacing)",
  },
  paragraphMedium: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-medium-size)",
    lineHeight: "var(--font-paragraph-medium-line-height)",
    fontWeight: "var(--font-paragraph-medium-weight)",
    letterSpacing: "var(--font-paragraph-medium-letter-spacing)",
  },
  paragraphSmallM: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-small-m-size)",
    lineHeight: "var(--font-paragraph-small-m-line-height)",
    fontWeight: "var(--font-paragraph-small-m-weight)",
    letterSpacing: "var(--font-paragraph-small-m-letter-spacing)",
  },
  paragraphSmall: {
    fontFamily: "var(--font-family-base)",
    fontSize: "var(--font-paragraph-small-size)",
    lineHeight: "var(--font-paragraph-small-line-height)",
    fontWeight: "var(--font-paragraph-small-weight)",
    letterSpacing: "var(--font-paragraph-small-letter-spacing)",
  },
} as const;
